module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowThin.46bb1c5.ttf";